export enum SecureStorageKeys {
  CUSTOM_TOKEN = "cellera_custom_token",
}

export enum SessionStorageKeys {
  SIGN_UP_EMAIL = "signUpEmail",
}
